<template>
  <nav class="navbar navbar-expand-lg sticky-top bg-header border-bottom shadow-xs" role="navigation">
    <div class="container header-container">
      <!-- Brand -->
      <router-link to="/" class="navbar-brand d-flex align-items-center gap-2 me-2">
        <img
          src="/icons/zane.png"
          alt="Zane Carter Logo"
          class="ws-logo"
          width="32"
          height="32"
        />
        <br></br>
        <span class="fw-bold ws-brand-text">  Zane Carter - iOS Engineer</span>
      </router-link>



    </div>
  </nav>
</template>

<script setup>
// purely presentational
</script>

<style scoped>
.bg-header { background: var(--header-bg); }
.header-container { min-height: 54px; padding-top: 0.25rem; padding-bottom: 0.25rem; }
.ws-logo { border-radius: 6px; object-fit: contain; }
.ws-brand-text { color: var(--header-ink); letter-spacing: .1px; font-size: 1.05rem; }

/* Nav links */
.navbar .nav-link { color: var(--ink); font-size: 0.95rem; }
.navbar .nav-link.router-link-active { color: var(--accent); font-weight: 600; }

/* Toggler */
.navbar-toggler {
  border: none;
}
.shadow-xs { box-shadow: 0 1px 0 rgba(0,0,0,.02); }
</style>